import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import CustomeButton from "~/components/Button";
import useTasks from "~/Pages/Process/actions/useTasks";
import PropTypes from "prop-types";
const PayslipSubmissionModal = ({ visible, closeModal, toastRef }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [taskData, setTaskData] = useState({});
  const { processmilestones } = useSelector((state) => state.milestones);

  const { handleStatusChange } = useTasks();

  const submitHandler = () => {
    setIsLoading(true);
    setTaskData((prev) => ({ ...prev, status: "completed" }));
    handleStatusChange(
      { code: "completed", name: "Completed" },
      taskData,
      showNotification,
    );
  };

  const showNotification = () => {
    setIsLoading(false);
    if (toastRef.current) {
      toastRef.current?.show({
        severity: "success",
        summary: "Success",
        detail: '"Submit final output to Customer” marked as Complete.',
        icon: "pi pi-check",
      });
    }
    closeModal();
  };

  useEffect(() => {
    const result =
      processmilestones
        .flatMap((milestone) => milestone.taskData || [])
        .find((task) => task.name === "Submit final output to Customer") ||
      null;

    if (result) {
      setTaskData(result);
    }
  }, [processmilestones]);
  return (
    <Dialog
      visible={visible}
      onHide={closeModal}
      draggable={false}
      className="payslip-submission-modal"
    >
      <div className="header flex flex-column justify-content-between">
        <p className="title">
          Are you sure you want to submit these files for final review and mark
          this submission as complete?
        </p>
        <div className="content flex flex-column gap-3">
          <p className="description">
            This action will finalize your submission, preventing any further
            changes to the uploaded files.
          </p>
          <div className="description">
            It is important to double-check that you are{" "}
            <b>submitting the correct documents</b> to avoid sharing private or
            personal information in the wrong Payroll process or with the wrong
            recipient/s.
          </div>
        </div>

        {/* footer action buttons */}
        <div className="action-buttons">
          <CustomeButton
            label="Cancel"
            variant="outlined"
            onClick={closeModal}
          />
          <CustomeButton
            label="Yes, Submit"
            variant="contained"
            onClick={submitHandler}
            loading={isLoading}
          />
        </div>
      </div>
    </Dialog>
  );
};

PayslipSubmissionModal.proptypes = {
  visible: PropTypes.bool,
  closeModal: PropTypes.func,
  toastRef: PropTypes.object,
};

export default PayslipSubmissionModal;
